module.exports = __webpack_public_path__ + "static/media/Zeus.154d011c.png";